import { DocumentReference, Timestamp } from '@angular/fire/firestore';
import { FormControl } from '@angular/forms';
import { FireStoreDocument } from '@shared/models/firestore';
import { IMobileNumber } from '@shared/models/numbers';
import { IUser } from '@user/models/user';

import { IOrganisation } from './organisations';

export interface IOrganisationUser extends FireStoreDocument {
	user: DocumentReference;
	organisation: DocumentReference;
	accessLevel: OrganisationUserAccessLevel;
	status: OrganisationMemberStatus;
	createdDate: Timestamp;
	updatedDate: Timestamp;
	joinDate: Timestamp | null;
	removeDate: Timestamp | null;
}

export enum OrganisationUserAccessLevel {
	EMPLOYEE = 'employee',
	OWNER = 'owner',
	ADMIN = 'admin',
}

export interface IOrganisationAndOrganisationUser {
	organisationUser: IOrganisationUser;
	organisation: IOrganisation;
}

export interface IUserAndOrganisationUser {
	organisationUser: IOrganisationUser;
	user: IUser;
}

export enum OrganisationMemberStatus {
	CURRENTLY_LOGGED_IN = 'currently logged in',
	INVITATION_PENDING = 'invitation pending',
	ACTIVE = 'active',
	DECLINED = 'declined',
	REMOVED = 'removed',
}

export interface IOrganisationInvitationCreateForm {
	email: FormControl<string | null>;
	phoneNumber: FormControl<IMobileNumber | null>;
	accessLevel: FormControl<OrganisationUserAccessLevel | null>;
}

export interface IOrganisationUserEditForm {
	accessLevel: FormControl<OrganisationUserAccessLevel>;
}
